<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-card flat>
        <custom-tabs v-model="tabs" grow v-if="containFields">
          <template v-slot:staticTabs>
            <v-tab >
              <div class="cornel-left" />
              <div class="cornel-right" />
              {{ $t("photo_logo_tab") }}
              <help-info
                :element-name="`${serviceName}-${componentName}-photo-logo-tab`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('photo_logo_tab')"
              />
            </v-tab>

            <v-tab v-if="containFields">
              <div class="cornel-left" />
              <div class="cornel-right" />
              {{ $t("gallery_image_tab") }}
              <help-info
                :element-name="`${serviceName}-${componentName}-gallery-image-tab`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('gallery_image_tab')"
              />
            </v-tab>
          </template>

          <template v-slot:middle>
            <div class="pt-4" />
          </template>

          <template v-slot:staticItems>
            <v-tab-item>
              <v-row no-gutters>
                <v-col
                  v-if="
                    !!valueComputed &&
                    valueComputed.hasOwnProperty('background')
                  "
                  class="pa-2"
                  cols="12"
                >
                  <v-card-title class="pb-0">{{
                    $t("template_image")
                  }}</v-card-title>

                  <pic-selector
                    :disabled="
                      !!category.field && category.field === 'background'
                    "
                    :edit-img="false"
                    :edit-name="false"
                    :field.sync="valueComputed.background"
                    :default-cat-name="$t('default_template_image')"
                    one-pic
                    single
                    :data="valueComputed"

                  />
                </v-col>
                <v-col v-if="containFields" class="pa-2" cols="12">
                  <v-card-title class="pb-0">{{
                    $t("background_image")
                  }}</v-card-title>
                  <pic-selector
                    :disabled="
                      !!category.field && category.field === 'headBackground'
                    "
                    :edit-img="false"
                    :edit-name="false"
                    :field.sync="valueComputed.headBackground"
                    :default-cat-name="$t('default_background_image')"
                    one-pic
                    single
                    :data="valueComputed"
                  />
                </v-col>

                <v-col class="pa-2" cols="12">
                  <v-card-title class="pb-0">{{
                    $t("upload_logo")
                  }}</v-card-title>

                  <pic-selector
                    :disabled="!!category.field && category.field === 'profile'"
                    :edit-img="false"
                    :edit-name="false"
                    :field.sync="valueComputed.profile"
                    :default-cat-name="$t('default_logo')"
                    one-pic
                    single
                    :data="valueComputed"

                  />
                </v-col>

                <v-col class="pa-2" cols="12">
                  <v-switch
                    v-if="containFields"
                    v-model="hasWelcome"
                    class="mt-0 mb-2"
                    hide-details
                    :label="$t('default_welcome')"
                  />
                </v-col>

                <template v-if="hasWelcome">
                  <!-- <pic-selector
                      v-if="hasWelcome"
                      v-model="welcomeGallery"
                      :edit-img="false"
                      :edit-name="false"
                      :field.sync="valueComputed.welcome"
                      :default-cat-name="$t('default_welcome')"
                      one-pic
                      single
                    /> -->
                  <previewer-qr
                    v-if="hasWelcome"
                    v-model="valueComputed"
                    style="width: 100%"
                  />
                </template>
              </v-row>
            </v-tab-item>

            <v-tab-item v-if="containFields">
              <pic-selector
                v-model="valueComputed.gallery"
                :single="!excludeNameSingle.includes($route.name)"
                :default-cat-name="$t('default_gallery')"
                :data="valueComputed"

              /> 
            </v-tab-item>
          </template>
        </custom-tabs>
        <v-row no-gutters v-else>
                <v-col
                  v-if="
                    !!valueComputed &&
                    valueComputed.hasOwnProperty('background')"
                  class="pa-2"
                  cols="12"
                >
                  <v-card-title class="pb-0">{{
                    $t("template_image")
                  }}</v-card-title>

                  <pic-selector
                    :disabled="
                      !!category.field && category.field === 'background'
                    "
                    :edit-img="false"
                    :edit-name="false"
                    :field.sync="valueComputed.background"
                    :default-cat-name="$t('default_template_image')"
                    one-pic
                    single
                    :data="valueComputed"

                  />
                </v-col>

                <v-col v-if="containFields || ['qr.socialMedia','qr.socialMedia', 
                'qr.name.editSocial', 'qr.name.id.editSocial', 'qr.id.editSocial',
                 'qr.create.editSocialModel', 'qr.create.SocialMediaModel',
                'qr.Qrtext', 'qr.name.editText', 'qr.name.id.editText', 'qr.bale',
        'qr.eitaa', 'qr.robika', 'qr.name.editBale', 'qr.name.id.editBale', 'qr.name.editEitaa','qr.name.id.editEitaa', 'qr.name.editRobika', 'qr.name.id.editRobika',

                  ].includes($route.name)" class="pa-2" cols="12">
                  <v-card-title class="pb-0">{{
                    $t("background_image")
                  }}</v-card-title>

                  <pic-selector
                    :disabled="
                      !!category.field && category.field === 'headBackground'
                    "
                    :edit-img="false"
                    :edit-name="false"
                    :field.sync="valueComputed.headBackground"
                    :default-cat-name="$t('default_background_image')"
                    one-pic
                    single
                    :data="valueComputed"

                  />
                </v-col>

                <v-col class="pa-2" cols="12">
                  <v-card-title class="pb-0">{{!isGiftRoute?
                    $t("upload_logo"):'تصویر پروفایل'
                  }}</v-card-title>
                  <pic-selector
                    :disabled="!!category.field && category.field === 'profile'"
                    :edit-img="false"
                    :edit-name="false"
                    :field.sync="valueComputed.profile"
                    :default-cat-name="$t('default_logo')"
                    one-pic
                    single
                    :data="valueComputed"

                  />
                </v-col>

                <v-col class="pa-2" cols="12">
                  <v-switch
                    v-if="containFields || ['qr.socialMedia','qr.socialMedia', 'qr.name.editSocial', 'qr.name.id.editSocial', 'qr.id.editSocial', 'qr.create.editSocialModel', 'qr.create.SocialMediaModel'].includes($route.name)"
                    v-model="hasWelcome"
                    class="mt-0 mb-2"
                    hide-details
                    :label="$t('default_welcome')"
                  />
                </v-col>

                <template v-if="hasWelcome">
                  <!-- <pic-selector
                      v-if="hasWelcome"
                      v-model="welcomeGallery"
                      :edit-img="false"
                      :edit-name="false"
                      :field.sync="valueComputed.welcome"
                      :default-cat-name="$t('default_welcome')"
                      one-pic
                      single
                    /> -->
                  <previewer-qr
                    v-if="hasWelcome"
                    v-model="valueComputed"
                    style="width: 100%"
                  />
                </template>
              </v-row>
      </v-card>
      <!-- <custom-popup>
        <v-btn class="me-2" color="primary" outlined @click="downloadTxt">
          <v-icon left>mdi-download</v-icon>
          دانلود فایل محصولات
        </v-btn>
      </custom-popup> -->
    </template>
  </help-info-wrapper>
</template>

<script>
import { Bus, rbAxios } from "@/main";
import PicSelector from "../../../components/UploadCenter/picSelector.vue";
import PicSelectorSingle from "../../../components/UploadCenter/picSelectorSingle";
import CatToUpload from "../../../components/UploadCenter/catToUpload";
import PreviewerQr from "./previewerQr.vue";
const GIFT_ROUTES = [
  "qr.gift",
  "qr.name.editgift",
  "qr.name.id.editgift",
  'modelsList.memories.edit',
  'qr.create.memories'
];

export default {
  name: "imageUploader",

  components: { CatToUpload, PicSelectorSingle, PicSelector, PreviewerQr },

  props: {
    value: { type: Object, default: () => ({}) },
  },

  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "imageUploader",
      url: process.env.VUE_APP_ROBOT,
      tabs: 0,
      category: {
        name: "",
        field: "",
      },
      profile: null,
      welcomeImg: this.valueComputed?.welcome || null,
      loading: false,
      wloading: false,
      showWelcome: false,
      transition: "scale",
      fieldsInclude: [
        "qr.photo",
        "qr.name.editPhoto",
        "qr.name.id.editPhoto",
        "qr.id.editPhoto",
        'qr.create.photoGalleryModel',
        'qr.create.photoGalleryedit',
        "qr.name.editVideo",
        "qr.name.id.editVideo",
        "qr.name.id.editVoice",
        "qr.name.editVoicePro",
        "qr.id.editVoicePro",
        "qr.name.editVoice",
        "qr.name.id.editVoicePro",
        "qr.name.id.editFeedback",
        "qr.name.consultationQrEdit",
        "qr.name.id.consultationQrEdit",
        "qr.name.id.editApplication",
        "qr.name.editApplication",
        "qr.name.editSocial",
        "qr.name.id.editSocial",
        "qr.name.editFeedback",
        "qr.name.id.editFeedback",
        "qr.application",
        "qr.consultationQr",
        "qr.video",
        "qr.voice",
        "qr.feedback",
        "qr.voicePro",
        "qr.id.editSocial",
        "qr.socialMedia",
        'qr.create.editSocialModel',
        'qr.create.SocialMediaModel',
        "qr.pdf",
        "qr.name.editPdf",
        "qr.name.id.editPdf",
        'qr.create.pdfGalleryedit',
        'qr.create.pdfGalleryModel',
        'qr.name.id.editgift',
        'qr.name.editgifit',
        'qr.gift',
        'modelsList.memories.edit',
        'qr.create.memories',
        'qr.Qrtext',
        'qr.name.editText',
        'qr.name.id.editText',
        'qr.bale',
        'qr.eitaa',
        'qr.robika',
        'qr.name.editBale',
        'qr.name.id.editBale',
        'qr.name.editEitaa',
        'qr.name.id.editEitaa',
        'qr.name.editRobika',
        'qr.name.id.editRobika',
        'qr.price.label',
        'qr.name.labelprice',
        'qr.name.labelprice.id'

        
      ],
      photo: {
        background: "",
        profile: "",
        headBackground: "",
      },
      profileGallery: [{ name: "", images: [] }],
      backgroundGallery: [{ name: "", images: [] }],
      welcomeGallery: [{ name: "", images: [] }],
      hasWelcome: false,
      hasGame: false,
      hasGif: false,
      excludeNameSingle: [
        "qr.name.product",
        "qr.name.id.product",
        "qr.product.shop",
        "qr.product.edit",
        "qr.product.productPro",
        "qr.name.productPro",
        "qr.name.id.productPro",
        'qr.create.productPro',
        'qr.create.productProModel',


      ],
    };
  },

  mounted() {
    this.$root.$on("clearDefaultData", this.clearDefaults);

    this.photo.profile = this.profile =
    this.value?.profile ||
    this.$coreApi3 + "/storage/s5wXoRhzyw9PkGXA8qnIL2yvA3TPiXhwsFrwjmeX.png";
    this.photo.welcome = this.welcomeImg = this.value?.welcome || null;
    this.photo.headBackground =
    this.value?.headBackground || "/media/business/faq/faq-1.webp";
    this.transition = this.value?.transition || "scale";
    this.hasWelcome = this.value?.hasWelcome || false;
  },

    computed: {
    isGiftRoute() {
      return GIFT_ROUTES.includes(this.$route.name);
    },
  
    transitionItems() {
      return [
        { text: this.$t("animation_scale"), value: "scale" },
        { text: this.$t("animation_slide_x"), value: "slideX" },
        { text: this.$t("animation_slide_y"), value: "slideY" },
        { text: this.$t("animation_fade"), value: "fade" },
      ];
    },
    rules() {
      return {
        image: [
          (value) =>
            !value || value.size < 2000000 || this.$t("image_size_error"),
        ],
        logo: [
          (value) =>
            !value || value.size < 2000000 || this.$t("logo_size_error"),
        ],
      };
    },
    valueComputed: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
        this.$forceUpdate();
      },
    },
    // valueComputed: {
    //   get() {
    //     return {
    //       background: "",
    //       headBackground: "/media/business/faq/faq-1.webp",
    //       profile:
    //         "https://api.terminalads.com/storage/s5wXoRhzyw9PkGXA8qnIL2yvA3TPiXhwsFrwjmeX.png",
    //       welcome: null,
    //       hasWelcome: false,
    //       transition: "scale",
    //       gallery: [{ name: this.$t("default_gallery"), images: [] }],
    //       ...this.value,
    //     };
    //   },
    //   set(val) {
    //     this.$emit("input", val);
    //     this.$forceUpdate();
    //   },
    // },
    containFields() {
      return !this.fieldsInclude.includes(this.$route.name);
    },
  },

  watch: {
    hasWelcome(val) {
      this.valueComputed.hasWelcome = val;
    },
    transition(val) {
      this.valueComputed.transition = val;
    },
    showWelcome: {
      handler(val) {
        Bus.$emit("showMe", val);
      },
      immediate: true,
      deep: true,
    },
    backgroundGallery: {
      deep: true,

      handler(val) {
        if (val[0] && val[0].images && val[0].images.length > 0) {
          this.valueComputed.headBackground = "";

          this.$nextTick(() => {
            this.valueComputed.headBackground = val[0].images[0].url;
          });
        } else {
          this.valueComputed.headBackground = null;
        }
      },
    },
    profileGallery: {
      deep: true,

      handler(val) {
        if (val[0] && val[0].images && val[0].images.length > 0) {
          this.photo.profile = "";
          this.profile = null;

          this.$nextTick(() => {
            this.valueComputed.profile = val[0].images[0].url;
          });
        } else {
          this.photo.profile = "";
          this.valueComputed.profile = null;
        }
      },
    },
    welcomeGallery: {
      deep: true,

      handler(val) {
        if (val[0] && val[0].images && val[0].images.length > 0) {
          this.welcomeImg = "";
          this.valueComputed.welcome = "";

          this.$nextTick(() => {
            this.valueComputed.welcome = val[0].images[0].url;
          });
        } else {
          this.welcomeImg = "";
          this.valueComputed.welcome = null;
        }
      },
    },
  },

  methods: {
    clearDefaults() {
      this.photo = {
        profile: null,
        welcome: null,
        transition: "scale",
        hasWelcome: false,
        hasGame: true,
        hasGif: true,
        previewerQr: {
          previewer: {
            gif: "",
            game: {
              type: "Game",
              count_play: 1,
              config: {},
            },
          },
          transition: "scale",
        },
      };
      this.profile = null;
      this.welcomeImg = null;
      this.transition = "scale";
      this.hasWelcome = false;
    },
  },
};
</script>

<style scoped></style>
